export const text =
["Check out my software (LearnToMod) or read my book (Minecraft Modding for Kids for Dummies)..."]
